import React from "react";
import { useParams, Link } from "react-router-dom";
import { staticPages } from "../mock";
import Header from "../components/Header";
import CartDrawer from "../components/CartDrawer";
import Footer from "../components/Footer";
import StorePresence from "../components/StorePresence";
import { MapPin, Phone, Mail, Clock, ChevronRight, ArrowRight } from "lucide-react";

export default function StaticPage() {
  const { slug } = useParams();
  const page = staticPages[slug];

  if (!page) {
    return (
      <div className="min-h-screen bg-white font-body">
        <Header />
        <CartDrawer />
        <div className="mx-auto max-w-3xl px-4 py-24 text-center lg:px-8">
          <h1 className="font-heading text-3xl font-extrabold text-navy">Page not found</h1>
          <p className="mt-3 text-navy/60">The page you're looking for doesn't exist.</p>
          <Link to="/" className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand px-8 py-3 font-heading font-bold text-white hover:bg-brand-dark">
            Back to home <ArrowRight size={16} />
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white font-body">
      <Header />
      <CartDrawer />

      {/* Breadcrumb */}
      <div className="border-b border-navy/10 bg-gray-50">
        <div className="mx-auto flex max-w-7xl items-center gap-1.5 px-4 py-3 text-xs text-navy/50 lg:px-8">
          <Link to="/" className="hover:text-brand">Home</Link>
          <ChevronRight size={12} />
          <span className="text-navy/80">{page.title}</span>
        </div>
      </div>

      {/* Hero band */}
      <div className="bg-navy">
        <div className="mx-auto max-w-4xl px-4 py-14 lg:px-8">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">{page.eyebrow}</p>
          <h1 className="mt-2 font-heading text-3xl font-extrabold text-white md:text-4xl">{page.title}</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-white/70 md:text-base">{page.intro}</p>
        </div>
      </div>

      {/* Body */}
      <div className="mx-auto max-w-4xl px-4 py-14 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1fr_320px]">
          <div className="space-y-8">
            {page.sections.map((s) => (
              <div key={s.heading}>
                <h2 className="font-heading text-xl font-extrabold text-navy">{s.heading}</h2>
                <p className="mt-3 text-sm leading-relaxed text-navy/70">{s.body}</p>
              </div>
            ))}
          </div>

          {/* Contact / info card */}
          <aside className="h-fit rounded-2xl border border-navy/10 bg-gray-50 p-6 md:sticky md:top-28">
            <h3 className="font-heading text-lg font-bold text-navy">Visit or contact us</h3>
            <ul className="mt-4 space-y-3 text-sm text-navy/70">
              <li className="flex items-start gap-2"><MapPin size={17} className="mt-0.5 shrink-0 text-brand" /> Unit 27, 14 Stanton Rd, Seven Hills NSW 2147</li>
              <li className="flex items-center gap-2"><Phone size={17} className="shrink-0 text-brand" /> <a href="tel:+61296206635" className="hover:text-brand">02 9620 6635</a></li>
              <li className="flex items-center gap-2"><Mail size={17} className="shrink-0 text-brand" /> <a href="mailto:enquiries@cyberfit.com.au" className="hover:text-brand">enquiries@cyberfit.com.au</a></li>
              <li className="flex items-start gap-2"><Clock size={17} className="mt-0.5 shrink-0 text-brand" /> Mon-Fri 10am-4pm · Sat 10am-2pm</li>
            </ul>
            <a
              href="tel:+61296206635"
              className="mt-5 flex items-center justify-center gap-2 rounded-full bg-brand px-6 py-3 font-heading font-bold text-white transition-colors hover:bg-brand-dark"
            >
              <Phone size={16} /> Call the Team
            </a>
          </aside>
        </div>
      </div>

      <StorePresence />
      <Footer />
    </div>
  );
}
